import React from "react";
import * as API from 'modules/app/API';
import { SetupPage } from 'areas/shared/pages/setup';
import ManageCompanyInfoTab from './manageCompanyInfo/ManageCompanyInfoTab';
import AssociatedUserTab from './associatedUsers/AssociatedUserTab';

class ManageCompanySetup extends React.Component {
    constructor(props) {
        super(props);
        this.state = this.initialState();
    }

    initialState() {
        return {
            list: [],
            loading: false
        };
    }

    componentDidMount() {
        this.setState({
            loading: true
        });
    }

    render() {

        let opts = {
            title: "Manage Company",
            description: "If you need to make any changes to Ownership or Business Information, it is the responsibility of the Majority Owner to contact VOCS support: <a href='mailto:certification@nvbdc.org'>certification@nvbdc.org</a>",
            recentType: "company",
            backToSearchMsg: "Back to Companies List",
            backToSingleResultMsg: "Back to Dashboard",
            singleResultCancelUrl: '/',
            backUrl: '/manageCompany',
            homeUrl: '/',
            list: {
                url: API.Biz.url('/vobSetup/searchManageVob'),
                rowKey: "certificationKey",
                columns: [
                    { key: 'name', name: 'Company Name', sortable: true, width: 250 },
                    { key: 'fein', name: 'Company FEIN/EIN', sortable: false, width: 130 },
                    { key: 'email', name: "Majority Owner's Email Address", sortable: false, width:220 },
                    { key: 'majorityOwner', name: 'Majority Owner', sortable: false },
                    { key: 'certificationNumber', name: 'App Id', sortable: false, width: 90 },
                    { key: 'generalStatus', name: 'Status', sortable: false, width: 130 },
                    { key: 'expirationDate', name: 'Expiration Date', sortable: false, width: 110 }
                ]   
            },
            tabs: [
                { key: "manageCompanyInfo", title: "Company Info", helpKey: "", comp: ManageCompanyInfoTab },
                { key: "associatedUserTab", title: "Users", helpKey: "", comp: AssociatedUserTab }
            ]
        };

        opts = Object.assign(opts, this.props);

        return (
            <SetupPage {...opts}
                enableSearch={false}
                enableExport={false}
                showTitle={false}
                redirectOnSingleResult={true} />
        );
    }
}

export default ManageCompanySetup;



// WEBPACK FOOTER //
// ./src/areas/companyManagement/manageCompany/ManageCompanySetup.js